import { Avatar, Button, Dialog, DialogTitle, Divider, Grid, Typography } from "@material-ui/core";
import { PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import TitleDialog from "~/components/modalBookingScreen/TitleDialog";
import Utils from "~/helpers/Utils";
import bookingTransactionService, { getOneBookingTransaction } from "~/services/bookingTransactionService";
import businessService from "~/services/businessService";
import feedService from "~/services/feedService";
import payPaymentService, { stripeKey } from "~/services/payPaymentService";
import { DialogBuilder } from "~/utils/DialogProvider";
import { mixpanelTrackEvent, getCountryName } from "~/utils/mixpanel";
import { getBookingOrigin } from "~/utils/bookingOrigin";
import { TIPO_ATENDIMENTO } from "~/utils/appointmentType";
import { useApiErrorModal } from "~/contexts/ApiErrorModalContext";
import _ from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { withRouter } from "react-router";
import { postEvent } from "~/services/mixpanelServices";

import DialogError from ".";
import SpinnerLoading from "../spinnerLoading/SpinnerLoading";
import ModalPaymentProcessing from "../ModalPaymentProcessing";
import ButtonDefault from "~/components/common/ButtonDefault";
import useStyles from "./style";
import SupportErrorDialog from "./SupportErrorDialog";

const DialogPayConfirm = (props) => {
	const { i18n, t } = useTranslation();
	const dialog = useContext(DialogBuilder);
	const { showApiError } = useApiErrorModal();
	const [clientSecret, setClientSecret] = useState(null);
	const [stripePromise, setStripePromise] = useState(null);
	const [errorMessage, setErrorMessage] = useState("Erro inesperado, tente novamente.");
	const [errorOpen, setErrorOpen] = useState(false);
	const [openErrorSupportDialog, setOpenErrorSupportDialog] = useState(false);
	const [bookingTransactionId, setBookingTransactionId] = useState(null);

	const appearance = {
		theme: "stripe",
	};

	const options = {
		clientSecret: clientSecret,
		appearance,
	};

	const showError = (message) => {
		if (showApiError({ message })) return;
		setErrorMessage(message);
		setErrorOpen(true);
	};

	const {
		postPayment,
		onClose,
		cardData,
		pix,
		checkoutInformation,
		totalPricingType,
		currency,
		coupon,
		payload,
		postBooking,
		setPixCode,
		onPixConfirmed,
		onPixUnblock,
		eventProps,
		showUpdateInfo,
		offerAccepted,
		laterPayment,
		handleBookingError,
		// Sessão de pacote agendada junto dos avulsos: só é usada depois do pagamento confirmado
		onPaymentConfirmed,
	} = props;

	const runOnPaymentConfirmed = async () => {
		if (!onPaymentConfirmed) return;
		try {
			await onPaymentConfirmed();
		} catch (err) {
			console.error("Falha ao usar a sessão do pacote depois do pagamento:", err);
		}
	};

	const isPostPayment = !_.isNil(postPayment) && !_.isObject(postPayment) && _.has(postPayment, "booking_external_id");

	const classes = useStyles();
	const { user } = useSelector((store) => store.auth);
	const { business } = useSelector((store) => store.business);
	const meStore = useSelector((store) => store.me);
	const me = Utils.safeParseJSON("@prit-web/meData", meStore);
	const [loading, setLoading] = useState(false);
	const [showPaymentProcessingModal, setShowPaymentProcessingModal] = useState(false);

	const currentUser = me || user || {};
	const isOwnerUser = !_.isEmpty(currentUser?.id) && !_.isEmpty(business?.ownerId) && currentUser.id === business.ownerId;

	const PRIT_FALLBACK_PHONE = "+5516996500540";

	const resolvePhoneNumbers = (me, meData) => {
		const phone = me?.phone || meData?.phone || meData?.phoneUnverified;
		if (!phone || phone.length < 14) return [PRIT_FALLBACK_PHONE];
		return [phone];
	};

	const publishBookingtranscation = async (bookTransactionId) => {
		try {
			const bookingTransactionPublishRequest = await bookingTransactionService.publishBooktranscation(
				bookTransactionId
			);
			return bookingTransactionPublishRequest.data;
		} catch (err) {}
	};

	const submitPayment = async () => {
		setLoading(true);
		if (postPayment) {
			setBookingTransactionId(postPayment.booking_external_id);
			postPay(postPayment.booking_external_id, postPayment.recipient_id, postPayment.payment_request_id);
		} else {
			if (currency === 'BRL') {
				mixpanelTrackEvent('Fazer_Pagamento', {
					'Meio_De_Pagamento': pix ? 'Pix' : 'Cartão',
					'Valor': (checkoutInformation?.anticipation_payment || 0) / 100,
					'Moeda': currency,
					'Pais': getCountryName(business),
					'Cadastrou_Empresa': business?.createdAt
				}, meStore?.me || user, business);
			}
			postBooking()
				.then(async (book) => {
					// if (book?.data && book?.data?.length > 0) {
					// 	pay(book.data[0].bookings[0].bookingTransactionId, business.id);
					// 	return;
					// }
					setBookingTransactionId(book.data.bookings[0].bookingTransactionId);
					pay(book.data.bookings[0].bookingTransactionId, business.id);
				})
				.catch((err) => {
					if (err.__handled__) {
						onClose();
						setLoading(false);
						return;
					}
					const message = err?.response?.data?.message;
					if (handleBookingError?.(err, message)) {
						onClose();
						setLoading(false);
						return;
					}
					showError(message || "Verifique sua conexão e tente novamente");
					setLoading(false);
				});
		}
	};

	const postPay = (bookingTransactionId, recipient_id, payment_request_id) => {
		const meData = JSON.parse(localStorage.getItem("@prit-web/meData"));
		if (currency === 'BRL') {
			mixpanelTrackEvent('Fazer_Pagamento', {
				'Meio_De_Pagamento': pix ? 'Pix' : 'Cartão',
				'Valor': (postPayment?.amount || 0) / 100,
				'Moeda': currency,
			}, currentUser, business);
		}
		businessService
			.getBusiness(business.id)
			.then(async (res) => {
				const businessUpdated = res.data;
				const postalCode = businessUpdated?.address?.postalCode?.trim();
				if (
					businessUpdated.phone.startsWith("+55") &&
					postalCode &&
					!/^\d{8}$/.test(postalCode.replace("-", ""))
				) {
					showError(t("adress problems"));
					setLoading(false);
					return;
				}
				const address = businessUpdated.address || business.adress;
				const paypamentPay = {
					booking_external_id: bookingTransactionId,
					recipient_id: recipient_id,
					payment_request_id: payment_request_id,
					card: cardData && {
						card_holder_name: cardData.name,
						card_expiration_date: cardData.expiry,
						card_number: cardData.number,
						card_cvv: cardData.cvc,
					},
					client: {
						id: user?.id || me?.id || localStorage.getItem("@prit-web/userId") || meData?.id,
						name:
							me?.name ||
							user?.displayName ||
							cardData?.name ||
							Utils.safeLocalGet("@prit-web/userName") ||
							meData?.name ||
							"Usuário Prit",
						email:
							user?.email ||
							cardData?.email ||
							me?.email ||
							meData?.email ||
							"contato@prit.app",
						country: "br",
						documents: [cardData ? cardData.cpf : pix],
						phone_numbers: resolvePhoneNumbers(me, meData),
						address: {
							street: address?.street || "Av. Prof. João Fiúsa",
							complementary: address?.unit || "",
							street_number: address?.number || "1901",
							neighborhood: address?.neighborhood || "Jardim Botânico",
							city: address?.city || "Ribeirão Preto",
							state: address?.state || "SP",
							zipcode: address?.postalCode || "14024250",
							country: "br",
						},
					},
					amount: postPayment.amount / 100,
					discount: checkoutInformation?.total_discounts / 100,
					payment_type: pix ? 5 : null,
				};
				if (coupon) {
					paypamentPay.coupon_id = coupon.coupon_id;
				}
				if (currency !== "BRL") {
					const res = await payPaymentService.postPayIntent(paypamentPay);
					setClientSecret(res.data.payment_intent_client_secret);
					setStripePromise(loadStripe(stripeKey, { stripeAccount: res.data.connect_account_id }));
				} else {
					const paymentTimeout = setTimeout(() => {
						setShowPaymentProcessingModal(true);
					}, 2000);

					payPaymentService
						.postAdvancedPaymentPay(paypamentPay)
						.then((paymentPayRequest) => {
							if (pix) {
								let waitingPixPayment = setInterval(() => {
									getOneBookingTransaction(bookingTransactionId).then((res) => {
										let status = res.data.paymentStatus;
										if (status !== "pending") {
											if (status === "partial" || status === "completed") {
												const typeLogin = Utils.safeLocalGet("@prit-web/TypeLogin");
												mixpanelTrackEvent('Novo_Agendamento', {
													"Forma_De_Agendamento": 'Web_Consumidor',
													"Meio_De_Pagamento": 'Pix',
													"Tipo_De_Login": typeLogin || null,
													"Origem_De_Agendamento": getBookingOrigin(),
													"Valor": postPayment?.amount / 100,
													"Moeda": currency,
													"tipo_atendimento": TIPO_ATENDIMENTO.INDIVIDUAL,
												}, currentUser, business, true);
												if (onPixUnblock) onPixUnblock();
												props.history.replace("/notificacoes/" + business?.id, {
													paymentSuccess: true,
												});
											}
											clearInterval(waitingPixPayment);
										}
									});
								}, 5000);
								setPixCode(paymentPayRequest.data.pix_qr_code);
								setLoading(false);
							} else {
								const typeLogin = Utils.safeLocalGet("@prit-web/TypeLogin");
								mixpanelTrackEvent('Novo_Agendamento', {
									"Forma_De_Agendamento": 'Web_Consumidor',
									"Meio_De_Pagamento": 'Cartao',
									"Tipo_De_Login": typeLogin || null,
									"Origem_De_Agendamento": getBookingOrigin(),
									"Valor": postPayment?.amount / 100,
									"Moeda": currency,
									"tipo_atendimento": TIPO_ATENDIMENTO.INDIVIDUAL,
								}, currentUser, business, true);
								if (isOwnerUser) {
									mixpanelTrackEvent('Pagamento_Posterior', { "Meio_De_Pagamento": 'Cartao' }, currentUser, business);
								}
								props.history.replace("/notificacoes/" + business?.id, {
									paymentSuccess: true,
								});
								feedService.postFeed(
									{
										business_id: recipient_id,
										title: "Pagamento posterior (cartão)",
										message: "Pagamento posterior (cartão)",
										booking_transaction_id: bookingTransactionId,
										data: {
											template: "payment",
											status: "processed",
											booking_transaction_id: bookingTransactionId,
											recipient_id: recipient_id,
											payment_request_id: payment_request_id,
											payment_type: "cartão",
											transaction_value: (postPayment.amount / 100).toFixed(2).replace('.', ','),
											send_notification: true
										}
									}
								).catch((_) => {});
								setLoading(false);
							}
						})
						.catch((err) => {
							const errorMsg = err?.response?.data?.message || err?.message;
							if (!isPostPayment) {
								bookingTransactionService.putBookingTransaction(bookingTransactionId);
							}
							if (errorMsg?.replace(/\s/g, "").toLowerCase().includes("objectreferencenotsettoaninstanceofanobject.")) {
								mixpanelTrackEvent("Erro_Pagamento_Stripe", { Meio_De_Pagamento: "Stripe" }, currentUser, business);
								setOpenErrorSupportDialog(true);
							} else {
								showError(errorMsg || "Verifique sua conexão e tente novamente");
							}
							setLoading(false);
						})
						.finally(() => {
							clearTimeout(paymentTimeout);
							setShowPaymentProcessingModal(false);
						});
				}
			})
			.catch((err) => {
				showError(err?.response?.data?.message || err?.message || "Verifique sua conexão e tente novamente");
				setLoading(false);
			});
	};

	const pay = (bookingTransactionId, recipient_id) => {
		const meData = JSON.parse(localStorage.getItem("@prit-web/meData"));
		businessService
			.getBusiness(business.id)
			.then(async (res) => {
				const businessUpdated = res.data;
				const postalCode = businessUpdated?.address?.postalCode?.trim();
				if (
					businessUpdated.phone.startsWith("+55") &&
					postalCode &&
					!/^\d{8}$/.test(postalCode.replace("-", ""))
				) {
					showError(t("adress problems"));
					setLoading(false);
					return;
				}
				const address = businessUpdated.address || business.adress;
				const paypamentPay = {
					booking_external_id: bookingTransactionId,
					recipient_id: recipient_id,
					card: cardData && {
						card_holder_name: cardData.name,
						card_expiration_date: cardData.expiry,
						card_number: cardData.number,
						card_cvv: cardData.cvc,
					},
					client: {
						id: user?.id || me?.id || localStorage.getItem("@prit-web/userId") || meData?.id,
						name: Utils.truncateNameToMaxLength(
								me?.name ||
								user?.displayName ||
								cardData?.name ||
								Utils.safeLocalGet("@prit-web/userName") ||
								meData?.name
							),
						email:
							user?.email ||
							cardData?.email ||
							me?.email ||
							meData?.email ||
							"contato@prit.app",
						country: "br",
						documents: [cardData ? cardData.cpf : pix],
						phone_numbers: resolvePhoneNumbers(me, meData),
						address: {
							street: address?.street || "Av. Prof. João Fiúsa",
							complementary: address?.unit || "",
							street_number: address?.number || "1901",
							neighborhood: address?.neighborhood || "Jardim Botânico",
							city: address?.city || "Ribeirão Preto",
							state: address?.state || "SP",
							zipcode: address?.postalCode || "14024250",
							country: "br",
						},
					},
					amount: /* postPayment ? */(checkoutInformation?.anticipation_payment / 100), /* : (checkoutInformation?.total_value_for_services / 100), */
					discount: checkoutInformation?.total_discounts / 100,
					payment_type: pix ? 5 : null,
				};
				if (coupon) {
					paypamentPay.coupon_id = coupon.coupon_id;
				}
				if (currency !== "BRL") {
					const res = await payPaymentService.postPayIntent(paypamentPay);
					setClientSecret(res.data.payment_intent_client_secret);
					setStripePromise(loadStripe(stripeKey, { stripeAccount: res.data.connect_account_id }));
				} else {
					publishBookingtranscation(bookingTransactionId);

					const paymentTimeout = setTimeout(() => {
						setShowPaymentProcessingModal(true);
					}, 2000);

					payPaymentService
						.postPaymentPay(paypamentPay)
						.then(async (paymentPayRequest) => {
							if (pix) {
								let waitingPixPayment = setInterval(() => {
									getOneBookingTransaction(bookingTransactionId).then((res) => {
										let status = res.data.paymentStatus;
										if (status !== "pending") {
											if (status === "partial" || status === "completed") {
												runOnPaymentConfirmed().then(() => {
													if (onPixConfirmed) {
														onPixConfirmed();
													} else {
														props.history.push(`/confirmation/${business?.id}`, {
															checkout: checkoutInformation,
															business: business,
															payload: payload,
															couponValue: coupon,
															totalPricingType: totalPricingType,
															offerAccepted: offerAccepted,
														});
													}
												});
											}
											clearInterval(waitingPixPayment);
										}
									});
								}, 5000);
								setPixCode(paymentPayRequest.data.pix_qr_code);
								setLoading(false);
							} else {
								const currentUser = me || user || {};
								const typeLogin = Utils.safeLocalGet("@prit-web/TypeLogin");
								mixpanelTrackEvent('Novo_Agendamento',
									{
										"Forma_De_Agendamento": 'Web_Consumidor',
										"Meio_De_Pagamento": 'Cartao',
										"Tipo_De_Login": typeLogin || null,
										"Origem_De_Agendamento": getBookingOrigin(),
										"Valor": checkoutInformation?.anticipation_payment / 100,
										"Moeda": currency || 'BRL',
										"tipo_atendimento": TIPO_ATENDIMENTO.INDIVIDUAL,
									},
									currentUser, business, true);
								await runOnPaymentConfirmed();
								props.history.push(`/confirmation/${business?.id}`, {
									checkout: checkoutInformation,
									business: business,
									payload: payload,
									couponValue: coupon,
									totalPricingType: totalPricingType,
									offerAccepted: offerAccepted,
								});
								let isOwnerUser = !_.isEmpty(currentUser?.id) && !_.isEmpty(business?.ownerId) && currentUser.id === business.ownerId;
								mixpanelTrackEvent('Agendamento_Confirmado', {}, currentUser, isOwnerUser ? business : {});
								setLoading(false);
							}
						})
						.catch((err) => {
							if (!isPostPayment) {
								bookingTransactionService.putBookingTransaction(bookingTransactionId);
							}
							let message = err?.response?.data?.message || err?.message;
							
							if (message && message.includes("Unexpected character encountered")) {
								setErrorMessage(t("Update your name to continue with payment"));
								setErrorOpen(true);
								setLoading(false);
								return;
							}
							if (message && message.includes && message.includes("email")) {
								showError("O email informado é inválido, por favor, verifique e tente novamente");
							} else {
								showError(message || "Verifique sua conexão e tente novamente");
							}
							setLoading(false);
						})
						.finally(() => {
							clearTimeout(paymentTimeout);
							setShowPaymentProcessingModal(false);
						});
				}
			})
			.catch((err) => {
				let message = err?.response?.data?.message || err?.message;

				switch (true) {
					case !!(message?.replace(/\s/g, "").toLowerCase().includes("objectreferencenotsettoaninstanceofanobject.")):
						mixpanelTrackEvent("Erro_Pagamento_Stripe", { Meio_De_Pagamento: "Stripe" }, currentUser, business);
						setOpenErrorSupportDialog(true);
						break;
					case !!(message?.includes("email")):
						showError("O email informado é inválido, por favor, verifique e tente novamente");
						break;
					default:
						showError(message || "Verifique sua conexão e tente novamente");
				}
				setLoading(false);
			});
	};

	const footer = () => {
		return (
			<div style={{ padding: "0 15px 15px 15px" }}>
				<Grid container justify="center">
					<Grid item xs={12} container justify="center">
						<Button onClick={submitPayment} className={classes.root}>
							{t("Make payment")}
						</Button>
					</Grid>
				</Grid>
			</div>
		);
	};

	const CheckoutForm = () => {
		const stripe = useStripe();
		const elements = useElements();
		const [isLoading, setIsLoading] = useState(false);

		const [openCheckoutStripe, setOpenCheckoutStripe] = useState(true);

		useEffect(() => {
			if (!stripe) {
				return;
			}
			const clientSecret = new URLSearchParams(window.location.search).get("payment_intent_client_secret");
			if (!clientSecret) {
				return;
			}

			stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
				switch (paymentIntent.status) {
					case "succeeded":
						dialog.withMessage(t("Payment succeeded")).show();
						break;
					case "processing":
						dialog.withMessage(t("Payment is being processed")).show();
						break;
					case "requires_payment_method":
						dialog.withMessage(t("Payment was not successful")).show();
						break;
					default:
						dialog.withMessage(t("Payment with error")).show();
						break;
				}
			});
		}, [stripe]);

		const handleSubmit = async (e) => {
			e.preventDefault();

			if (!stripe || !elements) {
				return;
			}

			setIsLoading(true);
			mixpanelTrackEvent('Fazer_Pagamento', {
				'Meio_De_Pagamento': 'Stripe',
				'Valor': (postPayment?.amount || 0) / 100,
				'Moeda': currency || 'BRL',
				'Pais': getCountryName(business),
				'Cadastrou_Empresa': business?.createdAt
			}, currentUser, business);

			const { error } = await stripe.confirmPayment({
				elements,
				confirmParams: {
					return_url: `${process.env.REACT_APP_URL}/confirmation/${business?.id}/bookingTransactionId/${bookingTransactionId}`,
				},
				redirect: "if_required",
			});

			if (error) {
				if (
					error.message !== "O número do seu cartão está incompleto." &&
					error.message !== "A data de expiração do seu cartão está incompleta." &&
					error.message !== "O código de segurança do seu cartão está incompleto."
				) {
					dialog.withMessage(error.message).show();
				}
			} else {
				// Pagamento confirmado sem redirect (ex: cartão sem 3DS)
				const typeLogin = Utils.safeLocalGet("@prit-web/TypeLogin");
				mixpanelTrackEvent(
					"Novo_Agendamento",
					{
						Forma_De_Agendamento: "Web_Consumidor",
						Meio_De_Pagamento: "Stripe",
						Tipo_De_Login: typeLogin || null,
						Origem_De_Agendamento: getBookingOrigin(),
						Valor: checkoutInformation?.anticipation_payment / 100,
						Moeda: currency || 'BRL',
						tipo_atendimento: TIPO_ATENDIMENTO.INDIVIDUAL,
					},
					currentUser,
					business,
					true
				);
				mixpanelTrackEvent("Agendamento_Confirmado", {}, currentUser, isOwnerUser ? business : {});
				localStorage.removeItem("@prit-web/checkoutPayload");
				localStorage.removeItem("@prit-web/stripeConfirmationState");
				await runOnPaymentConfirmed();
				props.history.push(`/confirmation/${business?.id}`, {
					checkout: checkoutInformation,
					singleServices: payload?.services || [],
					business: business,
					payload: payload,
					couponValue: coupon,
					totalPricingType: totalPricingType,
					offerAccepted: offerAccepted,
				});
			}

			setIsLoading(false);
		};

		return (
			<Dialog
				PaperProps={{
					style: { borderRadius: 20, maxWidth: 312, minHeight: 430 },
				}}
				open={clientSecret && stripe && openCheckoutStripe}
				title={t("Confirm payment")}>
				<DialogTitle>
					<TitleDialog onClose={onClose} message={t("Confirm payment")} />
				</DialogTitle>
				<div style={{ padding: "20px", display: "flex", justifyContent: "center" }}>
					<form id="payment-form" onSubmit={handleSubmit}>
						<PaymentElement id="payment-element" />
						<button
							style={{
								backgroundColor: "#3689ea",
								color: "#ffffff",
								height: 44,
								width: "100%",
								fontSize: 12,
								fontWeight: "normal",
								textTransform: "none",
								borderRadius: 20,
								marginTop: "45px",
								borderColor: "transparent",
								"&:hover": {
									backgroundColor: "#106ba3",
								},
							}}
							disabled={isLoading || !stripe || !elements}
							id="submit">
							{isLoading ? <SpinnerLoading loading={true} /> : t("Make payment")}
						</button>
					</form>
				</div>
			</Dialog>
		);
	};

	if (laterPayment) {
		return (
			<>
				<ModalPaymentProcessing
					open={showPaymentProcessingModal}
					onClose={() => setShowPaymentProcessingModal(false)}
				/>
				{clientSecret && stripePromise && (
					<Elements options={options} stripe={stripePromise}>
						<CheckoutForm />
					</Elements>
				)}
				<DialogError
					message={errorMessage}
					onOpen={errorOpen}
					onClose={() => setErrorOpen(false)}
					onOk={() => setErrorOpen(false)}></DialogError>

				<SupportErrorDialog
					open={openErrorSupportDialog}
  					onClose={() => setOpenErrorSupportDialog(false)}
  					title={t("paymentDeclined")}
  					message={t("paymentProcessingError")}
  					supportMessage={t("paymentSupportMessage")}
				/>
				<SpinnerLoading loading={loading} />
				<DialogTitle>{<TitleDialog onClose={onClose} message={t("Confirm payment")} />}</DialogTitle>
				<div style={{ padding: "0 20px " }}>
					<Typography className={classes.titlePoli}>{t("Cancellation Policy")}</Typography>
					<Typography className={classes.titlePoli}>{Utils.policyDetails(checkoutInformation, currency, t)}</Typography>
				</div>
				<div className={classes.container}>
					<div style={{ padding: 20 }}>
						<Avatar style={{ float: "left" }} alt={business.name} src={business.thumbnailUrl} />
						<Typography className={classes.businessName}>{business.name}</Typography>
						<Typography className={classes.businessAddress}>{business.address.street}</Typography>
					</div>
					<Divider />
					<div style={{ padding: "15px 20px" }}>
						<div style={{ display: "flex", justifyContent: "space-between" }}>
							<Typography className={classes.duration}>{t("Total services")}</Typography>
							<Typography className={classes.priceDetail}>
								{Utils.formatMoney((checkoutInformation?.total_value_for_services / 100), currency)}
							</Typography>
						</div>
							<div style={{ display: "flex", justifyContent: "space-between" }}>
								<Typography className={classes.priceDetailBlue}>{t("Payment to be made now")}:</Typography>
								<Typography className={classes.price}>
								{Utils.formatMoney((postPayment?.amount / 100), currency)}
							</Typography>
						</div>
					</div>
					<Divider />
					<div style={{ padding: 20, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
						<Typography className={classes.cardNumber} style={{ fontWeight: "bold", color: "#3689ea", fontSize: "10px" }}>
							{pix || Utils.formatCardNumber(cardData?.number)}
						</Typography>
						{business?.currency === "BRL" && (
							<Typography
								onClick={() => {
									showUpdateInfo();
								}}
								style={{
									height: "15px",
									fontSize: "12px",
									color: "#3689ea",
								}}>
								{t("Change card number")}
							</Typography>
						)}
					</div>
				</div>
				{footer()}
			</>
		);
	}

	const formatCPF = (value) => {
		if (!value) return "";
		const digits = value.replace(/\D/g, "");
		return digits
			.replace(/(\d{3})(\d)/, "$1.$2")
			.replace(/(\d{3})(\d)/, "$1.$2")
			.replace(/(\d{3})(\d{1,2})/, "$1-$2");
	};

	return (
		<>
			{clientSecret && stripePromise && (
				<Elements options={options} stripe={stripePromise}>
					<CheckoutForm />
				</Elements>
			)}
			<ModalPaymentProcessing
				open={showPaymentProcessingModal}
				onClose={() => setShowPaymentProcessingModal(false)}
			/>
			<DialogError
				title={errorMessage === t("Update your name to continue with payment") ? t("Invalid data") : null}
				message={errorMessage}
				onOpen={errorOpen}
				onClose={() => setErrorOpen(false)}
				onOk={() => setErrorOpen(false)}></DialogError>
			<SupportErrorDialog
				open={openErrorSupportDialog}
  				onClose={() => setOpenErrorSupportDialog(false)}
  				title={t("paymentDeclined")}
  				message={t("paymentProcessingError")}
  				supportMessage={t("paymentSupportMessage")}
			/>
			<SpinnerLoading loading={loading} />

			<div className={classes.pixConfirmContainer}>
				<div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
					<Typography className={classes.pixConfirmTitle} style={{ marginBottom: 0 }}>
						{pix ? t("Confirm Pix data") : t("Confirm card data")}
					</Typography>
					<button
						style={{
							background: "none",
							border: "none",
							fontSize: 18,
							color: "#999",
							cursor: "pointer",
							padding: 4,
							lineHeight: 1,
						}}
						onClick={onClose}
					>
						&#x2715;
					</button>
				</div>

				<div className={classes.pixConfirmBusinessRow}>
					<Avatar alt={business.name} src={business.thumbnailUrl} />
					<div>
						<Typography className={classes.pixConfirmBusinessName}>{business.name}</Typography>
						<Typography className={classes.pixConfirmBusinessAddress}>{business.address?.street}</Typography>
					</div>
				</div>

				<Divider className={classes.pixConfirmDivider} />
				
				<Typography className={classes.pixConfirmLabel}>
					{t("Amount to pay now")}
				</Typography>
				<Typography className={classes.pixConfirmValue}>
					{Utils.formatMoney((checkoutInformation?.anticipation_payment / 100), currency)}
				</Typography>

				<Divider className={classes.pixConfirmDivider} />

				{pix ? (
					<>
						<div className={classes.pixConfirmCpfRow}>
							<Typography className={classes.pixConfirmCpfLabel}>CPF</Typography>
							<Typography className={classes.pixConfirmCpfValue}>
								{formatCPF(pix)}
							</Typography>
						</div>

						<Divider className={classes.pixConfirmDivider} />

						{business?.currency === "BRL" && (
							<Typography
								className={classes.pixConfirmChangeLink}
								onClick={() => showUpdateInfo()}
							>
								{t("Change document")}
							</Typography>
						)}
					</>
				) : (
					<>
						<div className={classes.pixConfirmCpfRow}>
							<Typography className={classes.pixConfirmCpfLabel}>{t("Card number")}</Typography>
							<Typography className={classes.pixConfirmCpfValue}>
								{Utils.formatCardNumber(cardData?.number)}
							</Typography>
						</div>
						<div className={classes.pixConfirmCpfRow}>
							<Typography className={classes.pixConfirmCpfLabel}>{t("Validity")}</Typography>
							<Typography className={classes.pixConfirmCpfValue}>
								{cardData?.expiry?.replace(/(\d{2})(\d{2})/, "$1/$2")}
							</Typography>
						</div>

						<Divider className={classes.pixConfirmDivider} />

						{business?.currency === "BRL" && (
							<Typography
								className={classes.pixConfirmChangeLink}
								onClick={() => showUpdateInfo()}
							>
								{t("Change card number")}
							</Typography>
						)}
					</>
				)}

				<ButtonDefault onClick={submitPayment}>
					{pix ? t("Generate Pix") : t("Pay with card")}
				</ButtonDefault>
				
				<Typography className={classes.pixConfirmFooter}>{Utils.policyDetails(checkoutInformation, currency, t)}</Typography>
			</div>
		</>
	);
};

export default withRouter(DialogPayConfirm);
